import React, { ReactNode, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../ui/LoadingSpinner';
import { hideNativeSplashWhenReady } from '../../utils/nativeSplash';

const WELCOME_SESSION_KEY = 'fixnow:session-welcome-shown';

/**
 * 冷啟動時等待 Supabase session 與 currentUser 對齊，避免未登入閃屏或誤導向 /auth。
 * Auth 就緒後再隱藏原生 Splash。
 */
export function AuthBootstrapGate({ children }: { children: ReactNode }) {
  const { isLoading, currentUser } = useAuth();

  useEffect(() => {
    if (isLoading) return;
    void hideNativeSplashWhenReady();

    if (!currentUser) return;
    try {
      if (sessionStorage.getItem(WELCOME_SESSION_KEY)) return;
      sessionStorage.setItem(WELCOME_SESSION_KEY, '1');
    } catch {
      return;
    }
    toast.success(`歡迎回來，${currentUser.name || '使用者'}`, {
      duration: 2000,
      id: 'login-welcome',
    });
  }, [isLoading, currentUser]);

  if (isLoading) {
    return (
      <div
        className="min-h-dvh min-h-screen flex flex-col items-center justify-center bg-[#1d3557] px-6"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <img
          src="/app-icon.png?v=10"
          alt=""
          className="h-16 w-16 rounded-2xl object-cover shadow-md mb-6 ring-2 ring-white/20"
          aria-hidden
        />
        <LoadingSpinner />
        <p className="mt-4 text-sm text-white/80">
          {currentUser ? '歡迎回來…' : '正在恢復登入狀態…'}
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
